import React, { ReactElement } from 'react';
import { StyleSheet } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from '@alucio/lux-ui';
import { DRAWER_ENTITIES, drawerActions } from 'src/state/redux/slice/drawer';
import { RootState } from 'src/state/redux';
import UserEdit from '../UserEdit/UserEdit';
import EmailDrawerWrapper from '../EmailTemplateDrawer/EmailTemplateDrawerUI/EmailTemplateDrawer';
import AddMeeting from '../Meeting/AddMeeting';
import FileDrawer from '../FileDrawer/FileDrawer';
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal';
import TenantForm from '../TenantForm/TenantForm';
import CustomFormDrawer from '../CustomForms/CustomFormDrawer/CustomFormDrawer';
import DNACommonConfirmation from '../DNA/Modal/DNACommonConfirmation';

const styles = StyleSheet.create({
  mainWrapper: {
    backgroundColor: 'transparent',
  },
});

function RightSideBar(props) {
  const drawer = useSelector((state: RootState) => state.drawer)
  const dispatch = useDispatch();

  const checkFormDiscard = (cb: () => void) => {
    dispatch(
      DNAModalActions.setModal({
        isVisible: true,
        allowBackdropCancel: true,
        component: () => (<DNACommonConfirmation
          cancelText="Continue editing"
          confirmActionText="Discard changes"
          onConfirmAction={cb}
          title="Unsaved changes"
          descriptionText="All unsaved changes will be lost."
        />),
      }))
  }

  function toggleDrawer(ignoreChanges?:boolean): void {
    if (ignoreChanges) dispatch(drawerActions.toggle({}));
    else if (drawer.isOpen && drawer.hasPendingChanges && drawer.entity &&
      [DRAWER_ENTITIES.MEETING, DRAWER_ENTITIES.TENANT_FORM, DRAWER_ENTITIES.CRM_FORM].includes(drawer.entity)) {
      checkFormDiscard(() => dispatch(drawerActions.toggle({})))
    }
    else { dispatch(drawerActions.toggle({})); }
  }

  function getDrawerContent(): ReactElement | null {
    switch (drawer.entity) {
      case DRAWER_ENTITIES.EMAIL_TEMPLATE:
        return <EmailDrawerWrapper toggleDrawer={toggleDrawer} templateId={drawer.entityId} />;
      case DRAWER_ENTITIES.MEETING:
        return (
          <AddMeeting
            meetingId={drawer.entityId}
            toggleDrawer={toggleDrawer}
            autoSubmitToCRM={drawer.autoSubmitToCRM}
            autoSubmitToCRMSubmitType={drawer.autoSubmitToCRMSubmitType}
          />
        );
      case DRAWER_ENTITIES.FILES:
        return <FileDrawer toggleDrawer={toggleDrawer} />
      case DRAWER_ENTITIES.CRM_FORM:
        return (
          <CustomFormDrawer
            recordId={drawer.entityId}
            standaloneForm={drawer.standaloneForm}
            autoSubmitToCRM={drawer.autoSubmitToCRM}
          />
        );
      case DRAWER_ENTITIES.TENANT_FORM:
        return <TenantForm toggleDrawer={toggleDrawer} formId={drawer.entityId || ''} />
      case DRAWER_ENTITIES.USER:
        if (drawer.entityId || drawer.tenantId) {
          return (
            <UserEdit
              key={drawer.entityId || drawer.tenantId}
              toggleDrawer={toggleDrawer}
              userId={drawer.entityId}
              tenantId={drawer.tenantId}
            />
          );
        }
    }
    return null;
  }

  return (
    <Drawer
      open={drawer.isOpen}
      onClose={toggleDrawer}
      width={drawer.width}
      preventCloseOnBackdropPress={drawer.entity === DRAWER_ENTITIES.USER}
      animationTime={250}
      scrimStyles={{ position: 'absolute' }}
      style={styles.mainWrapper}
      orientation={drawer.orientation}
      drawerContent={getDrawerContent()}
    >
      {props.children}
    </Drawer>
  );
}

RightSideBar.displayName = 'RightSideBar';

export default RightSideBar;
